import { getAllPosts, getResourcePageParams, extractIdsFromCollectionUrl, extractTweets, extractCollections } from "controllers/seo";  
import { ResourcePage } from "components/dynamic-page/resource-page";  

export default function Resource({ postData, paths }) {

    return (
        <ResourcePage postData={postData} paths={paths} />
    );
}

export async function getStaticPaths() {
    // Return a list of possible value for id
    let paths = await getAllPosts({isResource: true});
    paths = paths.filter((x: any) => !x.params?.isDynamic);

    // console.log(paths);
    // paths = paths.concat(articles);

    return {
        paths,
        fallback: false,
    };
}


export async function getStaticProps({ params }) {

    let {postData, paths} = await getResourcePageParams(params.id);

    if (postData) {
        return {
            props: {
                postData,
                paths,
            }
        }
    }

    return {props: {}};
}